import { defineComponent as D, computed as E, watch as g, onMounted as L, createBlock as d, openBlock as c, unref as n, withCtx as s, createVNode as l, createElementVNode as p, toDisplayString as w, createElementBlock as M, createCommentVNode as V, Fragment as W, renderList as j, withModifiers as _, createTextVNode as k } from "vue";
import { ScalarDropdown as T, ScalarButton as $, ScalarDropdownItem as f, ScalarListboxCheckbox as S, ScalarDropdownDivider as z, ScalarIcon as A } from "@scalar/components";
import { useRouter as F } from "vue-router";
import { PathId as O } from "../../routes.js";
import { useActiveEntities as P } from "../../store/active-entities.js";
import { useWorkspace as R } from "../../store/store.js";
import { useLayout as q } from "../../hooks/useLayout.js";
const G = { class: "m-0 flex items-center gap-1.5 font-medium whitespace-nowrap" }, H = { class: "flex h-4 w-4 items-center justify-center" }, te = /* @__PURE__ */ D({
  __name: "EnvironmentSelector",
  setup(J) {
    const { activeCollection: a, activeWorkspace: r, activeEnvironment: u } = P(), { collectionMutators: C } = R(), { layout: y } = q(), I = F(), m = (e) => {
      a.value && r.value && (C.edit(
        a.value.uid,
        "x-scalar-active-environment",
        e
      ), r.value.activeEnvironmentId = e);
    }, N = () => {
      var e;
      return I.push({
        name: "environment.default",
        params: {
          [O.Workspace]: (e = r.value) == null ? void 0 : e.uid
        }
      });
    }, b = E(() => {
      const { value: e } = u, { value: t } = a;
      return (e == null ? void 0 : e.name) || (t == null ? void 0 : t["x-scalar-active-environment"]) || "No Environment";
    }), v = E(() => {
      const { value: e } = a, t = e == null ? void 0 : e["x-scalar-environments"];
      return t ? Object.entries(t).map(([o, i]) => ({
        ...i,
        uid: o,
        name: o
      })) : [];
    }), B = () => {
      const e = v.value;
      if (e.length > 0) {
        const t = e[e.length - 1];
        t != null && t.uid && m(t.uid);
      }
    };
    g(v, (e, t) => {
      e.length > t.length && B();
    });
    const x = (e) => {
      const t = e["x-scalar-active-environment"];
      t && a.value && r.value ? (a.value["x-scalar-active-environment"] = t, r.value.activeEnvironmentId = t) : r.value && (r.value.activeEnvironmentId = "");
    };
    return g(
      a,
      (e) => e && x(e)
    ), L(() => {
      a.value && x(a.value);
    }), (e, t) => (c(), d(n(T), { teleport: "" }, {
      items: s(() => [
        (c(!0), M(W, null, j(v.value, (o) => (c(), d(n(f), {
          key: o.uid,
          class: "group/item flex items-center gap-1.5 overflow-hidden text-ellipsis whitespace-nowrap",
          onClick: _((i) => m(o.uid), ["stop"])
        }, {
          default: s(() => {
            var i;
            return [
              l(n(S), {
                selected: ((i = n(a)) == null ? void 0 : i["x-scalar-active-environment"]) === o.uid
              }, null, 8, ["selected"]),
              k(" " + w(o.name), 1)
            ];
          }),
          _: 2
        }, 1032, ["onClick"]))), 128)),
        l(n(f), {
          class: "group/item flex items-center gap-1.5 overflow-hidden text-ellipsis whitespace-nowrap",
          onClick: t[0] || (t[0] = _((o) => m(""), ["stop"]))
        }, {
          default: s(() => {
            var o, i, h;
            return [
              l(n(S), {
                selected: ((o = n(u)) == null ? void 0 : o.uid) === "" && ((i = n(a)) == null ? void 0 : i["x-scalar-active-environment"]) === "" || ((h = n(u)) == null ? void 0 : h.name) === "No Environment"
              }, null, 8, ["selected"]),
              t[1] || (t[1] = k(" No Environment "))
            ];
          }),
          _: 1,
          __: [1]
        }),
        l(n(z)),
        n(y) !== "modal" ? (c(), d(n(f), {
          key: 0,
          class: "flex items-center gap-1.5",
          onClick: N
        }, {
          default: s(() => [
            p("div", H, [
              l(n(A), {
                icon: "Brackets",
                size: "sm"
              })
            ]),
            t[2] || (t[2] = p("span", { class: "leading-none" }, "Manage Environments", -1))
          ]),
          _: 1,
          __: [2]
        })) : V("", !0)
      ]),
      default: s(() => [
        l(n($), {
          class: "text-c-1 hover:bg-b-2 line-clamp-1 h-auto w-fit justify-start px-1.5 py-1.5 font-normal",
          fullWidth: "",
          variant: "ghost"
        }, {
          default: s(() => [
            p("h2", G, w(b.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
export {
  te as default
};
